"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userFullName = exports.userDisplayName = void 0;

var userDisplayName = function userDisplayName(user) {
  if (user.nickname) {
    return "".concat(user.nickname);
  }

  if (user.first_name) {
    return "".concat(user.first_name, " ").concat("".concat(user.last_name[0], ".") || '');
  }

  return user.email;
};

exports.userDisplayName = userDisplayName;

var userFullName = function userFullName(user) {
  if (user.first_name) {
    return "".concat(user.first_name, " ").concat(user.last_name);
  }

  return user.email;
};

exports.userFullName = userFullName;